const finiteNumber = (value: number | null | undefined): number | null => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const budgetUtilizationPercent = (
  spent: number | null | undefined,
  budget: number | null | undefined
): number | null => {
  const spentValue = finiteNumber(spent) ?? 0;
  const budgetValue = finiteNumber(budget) ?? 0;
  if (budgetValue <= 0) return null;
  return Number(((spentValue / budgetValue) * 100).toFixed(1));
};

export const budgetProgressWidth = (
  spent: number | null | undefined,
  budget: number | null | undefined
): string => {
  const percent = budgetUtilizationPercent(spent, budget);
  return `${Math.min(100, Math.max(0, percent ?? 0))}%`;
};

export const safePercentLabel = (value: number | null | undefined): string => {
  const parsed = finiteNumber(value);
  return parsed === null ? '-' : `${parsed.toFixed(0)}%`;
};
